import { Component, Input } from '@angular/core';
import { GenericMenu } from 'src/app/tools/abstract-classes/generic-menu';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/tools/services/config.service';


@Component({
  selector: 'assabil-packing-menu',
  templateUrl: './assabil-packing-menu.component.html',
  styleUrls: ['./assabil-packing-menu.component.scss']
})

export class AssabilPackingMenuComponent extends GenericMenu {

  @Input() shrinkMode : boolean = false;

  packingMenu = {
    'id'          : 'packing',
    'title'       : 'Gestion Traçabilité',
    'prefix'      : 'F',
    'blocs'  :  [
                      {
                        'id'         : 'packing-mobile',
                        'title'      : 'Fonctions - Mobile',
                        'icon'       :  'assets/images/icons/mobile-app.png',
                        'items'      : [
                                        {
                                            'id'        : 'packing-mobile-assetOrder',
                                            'label'     : 'Packing Order',
                                            'icon'      : "assets/icons/invoice.png",
                                            'route'     : './packing/packing-order-mobile'
                                        },
                                        {
                                            'id'        : 'packing-mobile-assetInventory'  ,
                                            'label'     : 'Pack Track',
                                            'icon'      : 'assets/icons/invoice.png',
                                            'route'     : './packing/packing-pack-packing-order-step-mobile'
                                        },
                                        {                       
                                          'id'        : 'branch-warehouse-transfers'  ,
                                          'label'     : 'Expédition de Transferts',
                                          'icon'      : "assets/icons/invoice.png",
                                          'route'     : './packing/packing-warehouse-transfer-expedition'
                                        },
                                        {
                                          'id'        : 'branch-warehouse-transfers'  ,
                                          'label'     : 'Réception de Transferts',
                                          'icon'      : "assets/icons/invoice.png",
                                          'route'     : './packing/packing-warehouse-transfer-reception'
                                        },
                                      ]
                      },

                      {
                        'id'         : 'packing-bo',
                        'title'      : 'Fonctions - Backoffice',
                        'icon'       :  'assets/images/icons/web-app.png',
                        'items'      : [
                                          {
                                            'id'        : 'packing-bo-packing-order'  ,
                                            'label'     : 'Packing Order',
                                            'icon'      : 'assets/icons/invoice.png',
                                            'route'     : './packing/packing-order'
                                        },
                                        {
                                            'id'        : 'packing-bo-assetCall'  ,
                                            'label'     : 'X y z',
                                            'icon'      : 'assets/icons/invoice.png',
                                            'route'     : './packing/asset-call-list'
                                        }, 
                                     ]
                      },
                      {
                      'id'         : 'packing-master-data',
                      'title'      : 'Administration',
                      'icon'       :  'assets/images/icons/settings.png',
                      'items'      : [
                                        {
                                          'id'        : 'asset-product-category-list',
                                          'label'     : 'Catégories de frigos',
                                          'icon'      : 'assets/icons/invoice.png',
                                          'route'     : './packing/asset-product-category-list'
                                      }, 
                                      {
                                          'id'        : 'asset-product-list',
                                          'label'     : 'Références de Frigos',
                                          'icon'      : 'assets/icons/invoice.png',
                                          'route'     : './packing/asset-product-list'
                                      }, 
                                     ]
                      }
                  ]
  }

  
  constructor(
    protected router              : Router,
    protected configService       : ConfigService,
    protected activatedRoute      : ActivatedRoute,
  ) { 
    super(router, activatedRoute);
  }


  select(itemId : string){
      if (itemId == 'asset-reports') {
        this.openReports();
      }
  }
  openReports(){
    let url= this.configService.config.reportsAppUrl;
    window.open(url)
  }

}
